import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import _ from 'lodash';
import PropTypes from 'prop-types';

FleetTransactionFilterView.propTypes = {
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
};

function FleetTransactionFilterView({
    setFilterDropdown,
    filterDropdown,
}) {
    // MARK: ---- PROPERTIES ----
    const objectTypeOptions = [
        {
            name: 'Tất cả',
            value: '',
        },
        {
            name: 'Doanh nghiệp VT',
            value: 'FLEET',
        },
        {
            name: 'Tài xế',
            value: 'DRIVER',
        },
    ];

    const transactionTypeOptions = [
        {
            name: 'Tất cả',
            value: '',
        },
        {
            name: 'Nạp tiền',
            value: 'TOPUP',
        },
        {
            name: 'Chi tiền',
            value: 'PAYMENT',
        },
    ];

    // MARK: ---- METHODS ----

    return (
        <div>
            <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                    name="search-bar"
                    placeholder='Theo mã giao dịch, mã tham chiếu, phiên sạc, người thực hiện'
                    value={filterDropdown.q}
                    onSubmit={(text) => {
                        const updateFilterDropdown = { ...filterDropdown, q: text };
                        setFilterDropdown(updateFilterDropdown);
                    }}
                />
            </div>
            <div className='row d-flex flex-row flex-wrap'>
                {/* loai doi tuong */}
                <KTDropdownFilter
                    label='Loại đối tượng'
                    filterKey="forRole"
                    options={objectTypeOptions}
                    selectedValue={filterDropdown.forRole}
                    additionalClassName='col-12 px-4'
                    handleChange={(value) => {
                        setFilterDropdown({ ...filterDropdown, forRole: value });
                    }}
                />
                {/* trang thai */}
                <KTDropdownFilter
                    label='Trạng thái'
                    filterKey="status"
                    options={[
                        { name: 'Tất cả', value: '' },
                        ...ChargeHelper.Data.walletTransactionStatusOptions
                    ]}
                    selectedValue={filterDropdown.status}
                    additionalClassName='col-12 px-4'
                    handleChange={(value) => {
                        const isSigned = value === 'SIGNED';
                        const newStatus = isSigned ? '' : value;
                        const newHasSignedContract = isSigned ? 1 : '';

                        setFilterDropdown({
                            ...filterDropdown,
                            status: newStatus,
                            hasSignedContract: newHasSignedContract,
                        });
                    }}
                />

                {/* loai giao dich */}
                <KTDropdownFilter
                    label='Loai giao dich'
                    filterKey="type"
                    options={transactionTypeOptions}
                    selectedValue={filterDropdown.type}
                    additionalClassName='col-12 px-4'
                    handleChange={(value) => {
                        setFilterDropdown({ ...filterDropdown, type: value });
                    }}
                />

                {/* khoang thoi gian */}
                <div className={`col-12 px-4 pt-2`}>
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Khoảng thời gian
                    </label>
                    <CustomDateRangePicker
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.selectedValue?.length > 0
                                ? filterDropdown.selectedValue
                                : dateFilter.baMuoiNgayGanNhat
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default FleetTransactionFilterView;
